// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailB":"B_wave2DetailB__OEZsL"};